import { render, staticRenderFns } from "./mobileIndex.vue?vue&type=template&id=0c18e195&scoped=true"
import script from "./mobileIndex.vue?vue&type=script&lang=js"
export * from "./mobileIndex.vue?vue&type=script&lang=js"
import style0 from "./mobileIndex.vue?vue&type=style&index=0&id=0c18e195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18e195",
  null
  
)

export default component.exports